import {
  TOOLBAR_SCENE,
  TOOLBAR_VR,
  TOOLBAR_SAY,
  TOOLBAR_SHARE,
} from '@/config/contant'

const ERR_NO = 100
const AR_TYPE_ID = 10009
const IMAGE_TYPE_ID = 10001
const VIDEO_TYPE_ID = 9
const POINT_TYPE_ID = 101

const TOOLS_MENU = [
  // {
  //   name: TOOLBAR_VOICE,
  //   icon: 'icon-volume',
  //   active_icon: 'icon-jingyin1'
  // },
  {
    name: TOOLBAR_SCENE,
    img: 'video',
    icon: 'icon-video-list',
    active_icon: 'icon-video-list',
  },
  {
    name: TOOLBAR_VR,
    img: 'vr',
    icon: 'icon-vr-outline2',
    active_icon: 'icon-vr-outline2',
  },
  {
    name: TOOLBAR_SAY,
    img: 'msg',
    icon: 'icon-message',
    active_icon: 'icon-message',
  },
  {
    name: TOOLBAR_SHARE,
    img: 'share',
    icon: 'icon-share',
    active_icon: 'icon-share',
  },
  // {
  //   name: TOOLBAR_FULL,
  //   icon: 'icon-quanping',
  //   active_icon: 'icon-quanping'
  // }
]

const API_FORM = {
  say: {
    id: 0,
    fk_video_id: 0,
    scene_id: 0,
    fk_user_id: 0,
    content: '',
    created: Date.now(),
    video_name: '',
    icon_src: '',
    nickname: '',
    avatar: '',
    replay_total: 0,
    comment_replay_items: [
      {
        id: 0,
        fk_user_id: 0,
        parent_id: 0,
        fk_comment_id: 0,
        content: '',
        created: Date.now(),
        nickname: '',
        avatar: '',
      },
    ],
  },
}

export default {
  errno: ERR_NO,
  SWF: 'krpano/krpano.swf',
  XML: 'krpano/data/newvideoxml.aspx',
  arTypeId: AR_TYPE_ID, // 素材类型
  imageTypeId: IMAGE_TYPE_ID,
  videoTypeId: VIDEO_TYPE_ID,
  pointTypeId: POINT_TYPE_ID,
  roamHotspotId: 1, // 热点类型
  linkHotspotId: 3,
  articleHotspotId: 6,
  imageHotspotId: 7,
  videoHotspotId: 9,
  toolsMenu: TOOLS_MENU,
  apiForm: API_FORM,
}
